import { createAuth0Client } from '@auth0/auth0-spa-js';

const domain = process.env.VUE_APP_AUTH0_DOMAIN || "login.racebuddy.co.uk"
const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID || "uzD9Q1D1LdaRLZYNdrA9zigJNK2WM06V"
const audience = process.env.VUE_APP_AUTH0_AUDIENCE || "https://api.racebuddy.co.uk"
const redirectUri = process.env.VUE_APP_AUTH0_REDIRECT_URI || `${window.location.origin}/callback`

export const auth0Config = {
  domain,
  clientId,
  authorizationParams: {
    redirect_uri: redirectUri,
    audience: audience,
    scope: 'openid profile email offline_access',
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
};

let auth0Client = null;

export const getAuth0Client = async () => {
  if (!auth0Client) {
    auth0Client = await createAuth0Client(auth0Config);
  }
  return auth0Client;
};

export const initializeAuth0 = async () => {
  const client = await getAuth0Client();

  // Handle the redirect callback
  if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
    await client.handleRedirectCallback();
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  return client;
};
